export default __webpack_public_path__ + "static/badge-color-light-9bebe88a12796c57952b4b61b2995dce28fbdf76fb8c41bc914e4045c2dad1a2.png";